export const REALTIME_SOCKET_STATUS = {
	IDLE: "idle",
	CONNECTING: "connecting",
	OPEN: "open",
	RECONNECTED: "reconnected",
	CLOSED: "closed",
} as const;

export type RealtimeSocketStatus = (typeof REALTIME_SOCKET_STATUS)[keyof typeof REALTIME_SOCKET_STATUS];

export const REALTIME_SOCKET_LIFECYCLE_STATUS = {
	OPEN: REALTIME_SOCKET_STATUS.OPEN,
	RECONNECTED: REALTIME_SOCKET_STATUS.RECONNECTED,
	CLOSED: REALTIME_SOCKET_STATUS.CLOSED,
} as const;

export type RealtimeSocketLifecycleStatus = (typeof REALTIME_SOCKET_LIFECYCLE_STATUS)[keyof typeof REALTIME_SOCKET_LIFECYCLE_STATUS];

export const REALTIME_WS_CLOSE_REASONS = {
	CLOSING: "closing",
} as const;

export type RealtimeWsCloseReason = (typeof REALTIME_WS_CLOSE_REASONS)[keyof typeof REALTIME_WS_CLOSE_REASONS];
